import { Field, NumberField } from '@base-ui/react';
import { FC } from 'react';

import MinusIcon from '@/assets/svg/ui-elements/minus.svg';
import PlusIcon from '@/assets/svg/ui-elements/plus.svg';

import HelperDescription from '../Helper/HelperDescription';
import Label from '../Label';
import {
  StyledDecrement,
  StyledGroup,
  StyledIncrement,
  StyledInput,
  StyledRoot,
  StyledStepperGroup,
} from './InputNumber.styled';
import type { InputNumberProps } from './types';

const InputNumber: FC<InputNumberProps> = ({
  label,
  optional,
  tooltip,
  topRightLabel,
  helperText,
  state = 'default',
  iconStart,
  placeholder,
  align = 'left',
  size = 'lg',
  showStepper = true,
  fullWidth = false,
  containerClassName,
  disabled,
  required,
  ...rootProps
}) => {
  const decrementButton = (
    <StyledDecrement>
      <MinusIcon />
    </StyledDecrement>
  );

  const incrementButton = (
    <StyledIncrement>
      <PlusIcon />
    </StyledIncrement>
  );

  return (
    <StyledRoot
      disabled={disabled}
      invalid={state === 'destructive'}
      className={containerClassName}
      $fullWidth={fullWidth}
    >
      {label && (
        <Field.Label
          render={
            <Label
              optional={optional}
              required={required}
              tooltip={tooltip}
              topRightLabel={topRightLabel}
            >
              {label}
            </Label>
          }
        />
      )}
      <NumberField.Root disabled={disabled} required={required} {...rootProps}>
        <StyledGroup $state={state} $fullWidth={fullWidth} $size={size}>
          {showStepper && align === 'center' && (
            <StyledStepperGroup>{decrementButton}</StyledStepperGroup>
          )}
          <StyledInput $align={align} $size={size} placeholder={placeholder} />
          {showStepper && align === 'left' && (
            <StyledStepperGroup>
              {decrementButton}
              {incrementButton}
            </StyledStepperGroup>
          )}
          {showStepper && align === 'center' && (
            <StyledStepperGroup>{incrementButton}</StyledStepperGroup>
          )}
        </StyledGroup>
      </NumberField.Root>
      <HelperDescription state={state} iconStart={iconStart} label={helperText} />
    </StyledRoot>
  );
};

InputNumber.displayName = 'InputNumber';

export default InputNumber;
